// extracted by mini-css-extract-plugin
module.exports = {"input":"input_input__1uuCn"};